import { render, staticRenderFns } from "./DataBackup.vue?vue&type=template&id=19ce619c&scoped=true"
import script from "./DataBackup.vue?vue&type=script&lang=js"
export * from "./DataBackup.vue?vue&type=script&lang=js"
import style0 from "./DataBackup.vue?vue&type=style&index=0&id=19ce619c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce619c",
  null
  
)

export default component.exports